import angular from 'angular'

import trainAsk from './services/ask.service'
import trainData from './services/data.service'
import trainFormat from './services/format.service'
import trainGo from './services/go.service'
import trainLocal from './services/local.service'
import trainMetadata from './services/metadata.service'
import trainNew from './services/new.service'
import trainRequest from './services/request.service'
import trainResource from './services/resource.service'
import train from './services/train.service'

import myTrainForm from './directives/forms/myTrainForm'
import myTrainSearchForm from './directives/forms/myTrainSearchForm'
import myTrainEditForm from './directives/forms/myTrainEditForm'
import myTrainDisplay from './directives/display/myTrainDisplay'
import myTrainSelectCard from './directives/select/myTrainSelectCard'

import trainButtons from './resources/buttons.resource'
import trainIcons from './resources/icons.resource'
import trainFields from './resources/fields.resource'
import trainLabels from './resources/labels.resource'

const name = 'train'
angular.module(name, [])
  // ===== SERVICES ===== //
  .factory('trainAsk', trainAsk)
  .factory('trainData', trainData)
  .factory('trainFormat', trainFormat)
  .factory('trainGo', trainGo)
  .factory('trainLocal', trainLocal)
  .factory('trainMetadata', trainMetadata)
  .factory('trainNew', trainNew)
  .factory('trainRequest', trainRequest)
  .factory('trainResource', trainResource)
  .factory('$$train', train)
  // ===== DIRECTIVES ===== //
  .directive('myTrainForm', myTrainForm)
  .directive('myTrainSearchForm', myTrainSearchForm)
  .directive('myTrainEditForm', myTrainEditForm)
  .directive('myTrainDisplay', myTrainDisplay)
  .directive('myTrainSelectCard', myTrainSelectCard)
  // ===== RESOURCES ===== //
  .factory('trainButtons', trainButtons)
  .factory('trainIcons', trainIcons)
  .factory('trainFields', trainFields)
  .factory('trainLabels', trainLabels)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/train.module.js